// src/pages/Step5.js
import React, { useState, useContext } from "react";
import { Container, Card } from "../components/Layout";
import styled from "styled-components";
import ProgressButton from "../components/ProgressButton";
import { ToastContext } from "../contexts/ToastProvider";

const Wrapper = styled.div`
  gap: 10px;
  justify-content: center;
  margin: 20px 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const ButtonCheckbox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  background-color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.primary : theme.colors.white};
  color: ${({ isChecked, theme }) =>
    isChecked ? theme.colors.white : theme.colors.primary};
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background-color: ${({ isChecked, theme }) =>
      isChecked ? theme.colors.primary : theme.colors.background};
  }
`;

function Step5({ onNext, onBack }) {
  const [selectedContraindications, setSelectedContraindications] = useState(
    []
  );
  const { toast } = useContext(ToastContext);

  const contraindications = [
    "Tidligere eller nuværende spiseforstyrrelse (f.eks. anoreksi eller bulimi)",
    "Nedsat leverfunktion",
    "Svær nedsat nyrefunktion",
    "Sygdom i bugspytkirtlen",
    "Svært hjertesvigt",
    "Type 1-diabetes",
    "Ingen af ovenstående",
  ];

  const handleToggle = (factor) => {
    if (factor === "Ingen af ovenstående") {
      if (!selectedContraindications.includes(factor)) {
        setSelectedContraindications([factor]);
      } else {
        setSelectedContraindications([]);
      }
    } else {
      if (selectedContraindications.includes("Ingen af ovenstående")) {
        return;
      }

      if (selectedContraindications.includes(factor)) {
        setSelectedContraindications(
          selectedContraindications.filter((item) => item !== factor)
        );
      } else {
        setSelectedContraindications([...selectedContraindications, factor]);
      }
    }
  };

  const handleNext = () => {
    if (!selectedContraindications.length) {
      toast.error("Vælg mindst én mulighed.");
      return;
    }
    if (!selectedContraindications.includes("Ingen af ovenstående")) {
      toast.error(
        "Du er ikke egnet til behandling på grund af kontraindikationer."
      );
      return;
    }
    onNext(selectedContraindications);
  };

  return (
    <Container>
      <Card>
        <h1>Kontraindikation</h1>
        <Wrapper>
          {contraindications.map((factor, index) => (
            <ButtonCheckbox
              key={index}
              isChecked={selectedContraindications.includes(factor)}
              onClick={() => handleToggle(factor)}
            >
              {factor}
            </ButtonCheckbox>
          ))}
        </Wrapper>
        <div>
          <ProgressButton text="Tilbage" onClick={onBack} />
          <ProgressButton text="Kom i gang nu" onClick={handleNext} />
        </div>
      </Card>
    </Container>
  );
}

export default Step5;
